// extracted by mini-css-extract-plugin
export default {"heading":"eE-z","signin":"fE-z","signupBtn":"gE-z","disabled":"hE-z"};